/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedosworkshoptwochallenges5Inputs */

const de__field_participatedosworkshoptwochallenges5 = /** @type {(inputs: _Field_Participatedosworkshoptwochallenges5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an OS-Workshop Two Challenges`)
};

/**

* @param {_Field_Participatedosworkshoptwochallenges5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedosworkshoptwochallenges5 = /** @type {((inputs?: _Field_Participatedosworkshoptwochallenges5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedosworkshoptwochallenges5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedosworkshoptwochallenges5(inputs)
});
export { _field_participatedosworkshoptwochallenges5 as "_field_participatedOSWorkshopTwoChallenges" }